// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__tszfg","label":"Category_label__5DhSR","content":"Category_content__3Wmgr","header":"Category_header__il0Ho","location":"Category_location__38wLF"};